// extracted by mini-css-extract-plugin
export default {"Box":"ExportSponsorships-module__Box--PdBhX","Text":"ExportSponsorships-module__Text--bXxHk","Button":"ExportSponsorships-module__Button--X8Pf6"};